import { render, staticRenderFns } from "./ModalProductImage.vue?vue&type=template&id=746f6412"
import script from "./ModalProductImage.vue?vue&type=script&lang=js"
export * from "./ModalProductImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports